import { render, staticRenderFns } from "./MonitorChatFilters.vue?vue&type=template&id=aa5fba74&scoped=true&"
import script from "./MonitorChatFilters.vue?vue&type=script&lang=js&"
export * from "./MonitorChatFilters.vue?vue&type=script&lang=js&"
import style0 from "./MonitorChatFilters.vue?vue&type=style&index=0&id=aa5fba74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5fba74",
  null
  
)

export default component.exports